<template>
  <v-card flat v-if="me">
    <v-list dense>
      <template v-for="item in accessItems">
        <v-list-group
          v-if="item.children"
          :key="item.text"
          v-model="item.active"
          :prepend-icon="item.icon"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="(child, i) in item.children"
            :key="i"
            :to="child.route"
            :href="child.href"
            :target="child.route ? '_self' : '_blank'"
            :class="[
              {
                'router-link-active--false': child.route && activeMenu != child.route.name,
              },
              {
                'v-list-item--active': child.route && activeMenu == child.route.name,
              },
            ]"
          >
            <v-list-item-content>
              <v-list-item-title v-text="child.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item
          v-else
          :key="item.text"
          v-model="item.active"
          link
          :to="item.route"
          :class="{
            'router-link-active--false': item.route && activeMenu != item.route.name,
          }"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-divider></v-divider>
      <v-list-item link @click="signout()">
        <v-list-item-content>
          <v-list-item-title class="d-flex align-center justify-center">
            <v-icon>mdi-logout</v-icon>
            <p class="ml-2 mb-0">로그아웃</p>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      items: [
        {
          icon: 'mdi-home',
          active: false,
          text: '홈으로',
          route: { path: '/' },
        },
        {
          icon: 'mdi-store',
          active: false,
          text: '쇼핑몰 연동하기',
          isAuth(me) {
            return me.businessSet.length > 0
          },
          route: { path: '/my/malls' },
        },
        {
          icon: 'mdi-bank',
          active: false,
          text: '계좌설정',
          isAuth(me) {
            return me.bankAccountSet.length < 1
              ? true
              : false && me.businessSet.length > 0 && me.storeSet.length > 0
          },
          route: { path: '/my/account/register' },
        },
        {
          icon: 'mdi-account',
          active: false,
          text: '마이페이지',
          isAuth(me) {
            return me.businessSet.length > 0 && me.storeSet.length > 0
          },
          route: { path: '/my' },
        },
        // {
        //   icon: 'mdi-information-outline',
        //   active: false,
        //   text: '공지사항',
        //   route: { path: '/notice' },
        // },
        // {
        //   icon: 'mdi-account',
        //   active: false,
        //   text: 'my',
        //   children: [
        //     { text: '마이페이지', route: { name: 'my' } },
        //     { text: '사업장정보등록', route: { name: 'my/store/register' } },
        //     { text: '사업자정보등록', route: { name: 'my/business/register' } },
        //     { text: '상점연동', route: { name: 'my/malls' } },
        //     { text: '계좌등록', route: { name: 'my/account/register' } },
        //   ],
        // },
      ],
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    activeMenu() {
      const name = this.$route.name
      if (name == null) {
        return ''
      }

      // this.$route.matched[0] : parent 라우터 또는 자기 자신
      const firstMatchedRouter = this.$router.options.routes.filter((router) => {
        return router.path === this.$route.matched[0].path
      })[0]

      return firstMatchedRouter ? firstMatchedRouter.name : ''
    },
    accessItems() {
      // 각 메뉴마다 auth를 추가
      const items = this.items.filter((v) => {
        return v.isAuth ? v.isAuth(this.me) : true
      })

      return items
    },
  },
  methods: {
    ...mapActions('auth', {
      storeSignout: 'signout',
    }),
    async signout() {
      await this.storeSignout()
      await this.$router.push('/')
    },
  },
}
</script>
<style lang="scss" scoped>
.router-link-active--false {
  color: $black;
  &::before {
    opacity: 0;
  }
}
</style>
